import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setSystems } from '../components/Cache/slices';
import { useUser } from '../components/Auth/AuthContext';

import Filters from '../components/Shared/Filters';

import { updateCache } from '../components/Shared/Functions';
import ActionButtons from '../components/Buttons/ActionButtons';
import Title from '../components/Shared/Title';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Pod from '../components/Shared/Pod';
import FormSelect from '../components/Form/FormSelect';
import FormSelectSystems from '../components/Form/FormSelectSystems';
import LinearProgress from "@mui/material/LinearProgress";

import { api } from '../components/Auth/API';
import Navbar from './Navbar';
import Modal from '../components/Shared/Modal';

const Domains = () => {
    const domains = ["attendance", "assessments", "behavior", "demographics", "enrollment", "grades"]
    return (
        <Grid container>
            {domains.map((domain, key) => (
                <Grid key={key} container className="Container">{domain}</Grid>
            ))}
        </Grid>
    )
}

const SystemList = props => {
    const options = props.sysconfig.data ? [
        ...props.sysconfig.data.map(x => ({
            value: x.SystemKey,
            system: x.SystemKey,
            label: x.Name
        })),
        { value: "manual", label: "Manual" },
        { value: "none", label: "None" }
    ] : []
    return (
        <FormSelect
            name={props.name}
            label={props.label}
            options={options}
            value={props.value || ''}
            // handler={e => handleChange(e)}
            handler={props.handler}
        />
    )
}

const System = () => {
    const dispatch = useDispatch();
    const user = useUser();
    const params = useParams();
    const createNew = (window.location.pathname.split('/').pop() === "new")

    const sysconfig = useSelector(state => state.sysconfig);
    const systems = useSelector(state => state.systems);

    const [data, setData] = useState();
    const [snackbar, setSnackbar] = useState(null);
    const [modal, setModal] = useState();
    const [selected, setSelected] = useState();

    const match = sysconfig.data ? sysconfig.data.find(x => x.SystemKey === data?.SystemKey) : null

    console.log(match)

    useEffect(() => {
        user.org && getData()
    }, [user])

    const getData = async () => {
        if (createNew) { setData({}); return }
        const response = await api(user, 'GET', 'systems', params.id, null, [
            x => setData(x),
            x => setSelected(x.SystemKey)
        ])
        response && setSnackbar(response)
    }
    const saveData = async () => {
        setSnackbar({ severity: 'info', message: "Saving Changes" })
        const { PK, SK, LastModified, ...body } = { ...data, ...{ Type: "system" } }
        console.log(body)
        // return 
        const response = await api(user, 'PUT', 'systems', params.id, body, [
            x => setData(x),
            x => updateCache(dispatch, setSystems, systems, x)
        ])
        response && setSnackbar(response)
    }
    const deleteData = async () => {
        setSnackbar({ severity: 'info', message: `Deleting ${data.Name}` })
        const response = await api(user, 'DELETE', 'systems', params.id, null, [
            x => updateCache(dispatch, setSystems, systems, x, params.id)
        ])
        response && setSnackbar(response)
    }

    const handleChange = e => {
        e.target.name === "SystemKey" && setSelected(e.target.value)
        console.log({ ...data, ...{ [e.target.name]: e.target.value } })
        setData({ ...data, ...{ [e.target.name]: e.target.value } })
    }

    const makeOptions = () => {
        if (!sysconfig.data) { return [] }
        // const match = sysconfig.data.find(x => x.SystemKey === data.SystemKey)
        return (match?.Products || [match?.Name]).map(x => ({
            value: x,
            label: x
        }))
    }

    return (
        <Navbar snackbar={snackbar}>
            <Modal data={modal} close={() => setModal()} delete={deleteData} />
            {data ?
                <Grid container>
                    <Grid item xs={12}>
                        <Grid container>
                            <Title
                                label={data.Name || ''}
                                systems={[data.SystemKey]}
                                handler={handleChange}
                            />
                            <ActionButtons
                                createNew={createNew}
                                updated={data.LastModified}
                                delete={() => setModal(`Are you sure you want to delete ${data.Name}?`)}
                                save={saveData}
                            />

                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container className="Container">
                            {/* <Subtitle
                                type="System"
                            /> */}
                            <FormSelectSystems
                                value={data.SystemKey}
                                // filter={x => x?.Actions}
                                handler={e => handleChange(e)}
                            />
                            <FormSelect
                                name="Name"
                                label="Product"
                                value={data.Name}
                                options={makeOptions()}
                                handler={handleChange}
                            />
                            <TextField
                                fullWidth
                                multiline
                                variant='standard'
                                name='Description'
                                label="Description"
                                placeholder='Description'
                                defaultValue={data?.Description}
                                onChange={e => handleChange(e)}
                            />
                        </Grid>
                    </Grid>


                    <Grid item xs={12}>
                                {}

                    </Grid>


                    <Grid item xs={12}>
                        <Grid container className="Container">
                            <TextField
                                fullWidth
                                multiline
                                variant="standard"
                                name="ContactName"
                                label="Contact Name"
                                placeholder="Contact Name"
                                defaultValue={data?.ContactName}
                                onChange={e => handleChange(e)}
                            />
                            <TextField
                                fullWidth
                                multiline
                                variant="standard"
                                name="ContactEmail"
                                label="Contact Email"
                                placeholder="Contact Email"
                                defaultValue={data?.ContactEmail}
                                onChange={e => handleChange(e)}
                            />
                            <TextField
                                fullWidth
                                multiline
                                variant="standard"
                                name="Contact"
                                label="Contact Phone"
                                placeholder="Contact Phone"
                                defaultValue={data?.ContactPhone}
                                onChange={e => handleChange(e)}
                            />
                        </Grid>
                    </Grid>

                    {/* Records */}
                    <Grid container >
                        <Grid item xs={6} sx={{ pr: 0.5 }}>
                            <Grid container className="Container">
                                {["Roster", "Auth"].map((x, key) => (
                                    <Grid item xs={12} key={key}>
                                        {["Staff", "Students"].map((y, key) => {
                                            return (
                                                <Grid item key={key}>
                                                    <SystemList
                                                        name={x + y}
                                                        label={x + " " + y}
                                                        value={data[x + y]}
                                                        sysconfig={sysconfig}
                                                        handler={e => handleChange(e)}
                                                    />
                                                </Grid>
                                            )
                                        })}
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* 
                    <Grid container className="Container">
                        <Grid item xs={6} sx={{ pr: 0.5 }}>
                            <Subtitle type="Source" />
                            {selected && jobs.data && jobs.data.filter(x => x.StateMachine.split('-')[0] === selected).map((x, key) => {
                                return (
                                    <Grid key={key}>
                                        <MatchLink type="jobs" item={x} />
                                    </Grid>
                                )
                            })}
                        </Grid>
                        <Grid item xs={6} sx={{ pl: 0.5 }}>
                            <Subtitle type="Target" />
                            {selected && jobs.data && jobs.data.filter(x => x.StateMachine.split('-')[1] === selected).map((x, key) => {
                                return (
                                    <Grid key={key}>
                                        <MatchLink type="jobs" item={x} />
                                    </Grid>
                                )
                            })}
                        </Grid>
                    </Grid>
                     */}

                    <Grid item xs={12}>
                        {sysconfig.data &&
                            <Grid container className="Container">
                                <FormSelectSystems
                                    value=""
                                />
                                {sysconfig.data.map((x, key) => {
                                    return (
                                        <Pod key={key}>
                                            <Title
                                                row
                                                systems={[x?.SystemKey]}
                                                label={x?.Name}
                                            />
                                        </Pod>
                                    )
                                })}
                            </Grid>
                        }
                    </Grid>
                </Grid>
                :
                <Grid item xs={12}><LinearProgress /></Grid>
            }
        </Navbar>
    )
}

export default System;